import {  HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import {SessionStorageService} from "../web/session.storage.service";
import {AuthService} from "../web/auth.service";


@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private sessionStorage: SessionStorageService, private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    //this.isRefreshing = false;
    let authReq = req;
    const token = this.sessionStorage.getToken();

    if (token != undefined) {
        authReq = this.addTokenHeader(req, token);
    }

    return next.handle(authReq).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && !authReq.url.includes('auth/login') && error.status === 401) {
        //return this.handle401Error(authReq, next, token);
        this.authService.logout(false);
      }
      return throwError(error);
    }));
  }


  private addTokenHeader(request: HttpRequest<any>, token: string) {

    return request.clone({
      setHeaders : {
        Authorization : `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
      }
    });
  }
}
